import type { PortableTextBlock } from '@portabletext/react';
import type { SanityDocument } from '@sanity/client';
import SimpleRichText from '../richTextComponents/SimpleRichText';
import { simpleRichTextGroq } from '../richTextComponents/simpleRichTextGroq';
import Definition from './Definition';
import * as style from './Definition.module.css';

export const definitionItemGroq = /* groq */ `{
    _id,
    _type,
    "slug": slug.current,
    name,
    summary,
    description[] ${simpleRichTextGroq},
    'synonyms': *[_type == ^._type && mainEntry._ref == ^._id].name,
    mainEntry -> {
        'slug': slug.current,
        name,
    },
    'listPage': *[_type == 'listPage' && listType == ^._type][0] { _id, title },
}`;

export interface DefinitionItemProps extends SanityDocument {
    _type: 'definition';
    slug: string;
    name: string;
    summary: string;
    description: PortableTextBlock[];
    synonyms: string[];
    mainEntry?: { name: string; slug: string };
    listPage: { _id: string; title: string; path: string };
}

export default function DefinitionItem({ name, summary, mainEntry, description, synonyms, slug, listPage }: DefinitionItemProps) {
    return (
        <div className={style.definition} id={name[0]?.toLowerCase()} itemScope itemType="https://schema.org/DefinedTerm">
            <details id={slug} data-toggle-context="definisjon">
                <summary>
                    <Definition name={name} summary={summary} slug={slug} listPage={listPage} synonyms={synonyms} />
                    {mainEntry && (
                        <p>
                            <span>Se: </span>
                            <a href={`${listPage?.path}?id=${mainEntry.slug}`}>{mainEntry.name}</a>
                        </p>
                    )}
                </summary>
                <div className={style.definitionInfo}>
                    <SimpleRichText value={description} />
                </div>
            </details>
        </div>
    );
}

export function DefinitionItemPage({ name, summary, description, synonyms, slug, mainEntry, listPage }: DefinitionItemProps) {
    return (
        <div className={style.definition} id={name[0]?.toLowerCase()}>
            <div className={style.details}>
                <div className={style.summary}>
                    <Definition name={name} summary={summary} slug={slug} listPage={listPage} synonyms={synonyms} title="h1" />
                    {mainEntry && (
                        <p>
                            <span>Se: </span>
                            <a href={`${listPage?.path}?id=${mainEntry.slug}`}>{mainEntry.name}</a>
                        </p>
                    )}
                </div>
                <div className={style.definitionInfo}>
                    <SimpleRichText value={description} />
                </div>
            </div>
        </div>
    );
}
